export {
  isPersonaCoverRegenerated,
  isPersonaCoverRegenerating,
  resolvePersonaCardBandImage,
} from "@shared/persona-cover";

export function resolvePersonaCoverImage(
  personaImageUrl: string | null | undefined,
  primaryCharacterAvatarUrl: string | null | undefined,
): string | null {
  return personaImageUrl ?? primaryCharacterAvatarUrl ?? null;
}